import { FC } from 'react';

import type { ArticleOnce } from '@/entities/article';
import { DownloadButton } from '@/shared/ui';

import styles from './articleDownload.module.scss';

interface ArticleDownloadProps {
  value: ArticleOnce;
}

const ArticleDownload: FC<ArticleDownloadProps> = (props) => {
  const { value } = props;
  const { original_pdf } = value;

  if (!original_pdf) {
    return null;
  }

  return (
    <article className={styles.container}>
      <div className={styles.container__titleBlock}>
        <p className={styles.container__title}>Китайский оригинал</p>
      </div>
      <DownloadButton value={value} />
    </article>
  );
};

export default ArticleDownload;
